import { render, staticRenderFns } from "./MarketplaceAdmin.vue?vue&type=template&id=644888de&scoped=true&"
import script from "./MarketplaceAdmin.vue?vue&type=script&lang=js&"
export * from "./MarketplaceAdmin.vue?vue&type=script&lang=js&"
import style0 from "./MarketplaceAdmin.vue?vue&type=style&index=0&id=644888de&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "644888de",
  null
  
)

export default component.exports